import script from "./UInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UInput.vue?vue&type=script&setup=true&lang=ts"

import "./UInput.vue?vue&type=style&index=0&id=1f941760&lang=scss"

const __exports__ = script;

export default __exports__